import { render } from "./agregarCliente.vue?vue&type=template&id=f2813e9e&scoped=true"
import script from "./agregarCliente.vue?vue&type=script&lang=js"
export * from "./agregarCliente.vue?vue&type=script&lang=js"

import "./agregarCliente.vue?vue&type=style&index=0&id=f2813e9e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\reclasin-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2813e9e"]])

export default __exports__